<template>
  <div class="bodyback-light pages">
    <notifications></notifications>
    <navmenu :menuMobile="true"></navmenu>

    <div class="container pb-0 pt-md-5 pt-sm-5 pt-5">
      <div class="row justify-content-center">
        <div class="col-xl-5 col-lg-6 col-md-8 col-sm-9 col-12 forms">
          <form action="">
            <div class="text-center custom-col mt-5">
              <h1 class="title-view-2 mb-1">Forgot Password</h1>
              <div class="textInHorizontalLine">
                <span>Suppliers</span>
              </div>
            </div>
            <div class="card pb-3 mt-4 mb-2">
              <span class="d-block f2 text-center mb-3">
                We will send you an email with a link to retrieve your password
              </span>

              <div class="col-12">
                <base-input
                  label="Email"
                  placeholder="Email"
                  v-model="$v.data.email.$model"
                  type="email"
                  :error="getEmailValidationMessage($v.data.email)"
                  markrequired
                  indexTab="1"
                  :focusact="true"
                ></base-input>

                <div class="text-center">
                  <base-button
                    type="primary"
                    class="min-button"
                    @click="requestNewPassword()"
                    tabindex="2"
                    >Send <i class="ml-2 mr-0 flaticon-send"></i>
                  </base-button>
                </div>
              </div>

              <div class="loading mt-3" v-if="requestStatus">
                <div class="dot"></div>
                <div class="dot"></div>
                <div class="dot"></div>
                <div class="dot"></div>
                <div class="dot"></div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <layoutFooter class="footer-pages"></layoutFooter>
  </div>
</template>

<script>
import Navbarpages from "@/views/Layout/Navbarpages";
import Swal from "sweetalert2";
import endpoint from "../Commons/Services/index";
import layoutFooter from "../Layout/ContentFooter";
import { required, email } from "vuelidate/lib/validators";
export default {
  name: "forgotpassword",
  components: {
    navmenu: Navbarpages,
    layoutFooter: layoutFooter
  },
  data() {
    return {
      data: {
        email: ""
      },
      requestStatus: false
    };
  },
  created() {},
  methods: {
    async requestNewPassword() {
      try {
        if (!this.$v.$invalid) {
          this.requestStatus = true;
          let { data } = await endpoint.auth.services.forgotPassword(
            this.data.email
          );
          this.requestStatus = false;
          if (data.status) {
            let result = await Swal.fire({
              title: "Success",
              html:
                "We have sent you an email to the address provided. <br> Check your inbox",
              imageUrl: require("rhomtrip_assets/src/img/icons/alerts/success.png"),
              buttonsStyling: false,
              focusConfirm: false,
              reverseButtons: true,
              confirmButtonText: "Accept",
              confirmButtonClass: "btn btn-primary btn-small-one"
            });
            this.$router.push("/");
          } else {
            let result = await Swal.fire({
              title: "Error",
              html:
                "Sorry, your request couldn't be processed. <br> Please try again.",
              imageUrl: require("rhomtrip_assets/src/img/icons/alerts/error.png"),
              buttonsStyling: false,
              focusConfirm: false,
              reverseButtons: true,
              confirmButtonText: "Accept",
              confirmButtonClass: "btn btn-primary btn-small-one"
            });
            this.$router.push("/");
          }
        } else {
          this.$v.data.$touch();
        }
      } catch (error) {
        this.requestStatus = false;
        let result = await Swal.fire({
          title: "Error",
          html:
            "Sorry, your request couldn't be processed. <br> Please try again.",
          imageUrl: require("rhomtrip_assets/src/img/icons/alerts/error.png"),
          buttonsStyling: false,
          focusConfirm: false,
          reverseButtons: true,
          confirmButtonText: "Accept",
          confirmButtonClass: "btn btn-primary btn-small-one"
        });
        this.$router.push("/");
      }
    },
    async verifyOperatorEmail(email) {
      try {
        if (email) {
          let { data } = await endpoint.auth.services.checkUniqueEmail(
            email.toLowerCase()
          );
          if (data.status) {
            return data.data.status;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    },
    validateEmail(email) {
      return /^[\w+\-\.]+@[\w-]+(\.[a-zA-Z]{2,}){1,}$/.test(email);
    },
    getEmailValidationMessage(email) {
      if (email.$error) {
        if (!email.required) {
          return "Enter a valid email.";
        } else if (!email.email) {
          return "Email is invalid.";
        } else if (!email.customValidator) {
          return "Email address not found.";
        }
      } else {
        return "";
      }
    }
  },
  validations: {
    data: {
      email: {
        required,
        email,
        customValidator: async function(value) {
          if (this.validateEmail(value)) {
            return await this.verifyOperatorEmail(value);
          } else {
            return false;
          }
        }
      }
    }
  }
};
</script>
